"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqPrimitiveInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var Either_1 = require("fp-ts/Either");
var Eq_1 = require("fp-ts/Eq");
var Option_1 = require("fp-ts/Option");
var pipeable_1 = require("fp-ts/pipeable");
var ReadonlyArray_1 = require("fp-ts/ReadonlyArray");
var ReadonlyNonEmptyArray_1 = require("fp-ts/ReadonlyNonEmptyArray");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var getOptionalEq = function (eq) { return ({
    equals: function (a, b) { return (a === undefined ? b === undefined : b !== undefined && eq.equals(a, b)); }
}); };
/**
 *  @since 0.0.1
 */
exports.eqPrimitiveInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.EqURI,
    date: function (config) { return function (env) {
        return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eq.contramap(Eq_1.eqNumber, function (date) { return date.getTime(); }), env, {}));
    }; },
    boolean: function (config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqBoolean, env, {})); }; },
    string: function (config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqString, env, {})); }; },
    number: function (config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqNumber, env, {})); }; },
    bigint: function (config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqStrict, env, {})); }; },
    stringLiteral: function (k, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqString, env, {})); }; },
    numberLiteral: function (k, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqNumber, env, {})); }; },
    oneOfLiterals: function (k, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqStrict, env, {})); }; },
    tag: function (k, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqString, env, {})); }; },
    keysOf: function (keys, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqStrict, env, {})); }; },
    nullable: function (getType, config) { return function (env) {
        return pipeable_1.pipe(getType(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Option_1.getEq(eq), env, { eq: eq })); });
    }; },
    optional: function (getType, config) { return function (env) {
        return pipeable_1.pipe(getType(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(getOptionalEq(eq), env, { eq: eq })); });
    }; },
    mutable: function (getType, config) { return function (env) {
        return pipeable_1.pipe(getType(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(eq, env, { eq: eq })); });
    }; },
    array: function (getType, config) { return function (env) {
        return pipeable_1.pipe(getType(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(ReadonlyArray_1.getEq(eq), env, { eq: eq })); });
    }; },
    nonEmptyArray: function (getType, config) { return function (env) {
        return pipeable_1.pipe(getType(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(ReadonlyNonEmptyArray_1.getEq(eq), env, { eq: eq })); });
    }; },
    uuid: function (config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.eqString, env, {})); }; },
    either: function (e, a, config) { return function (env) {
        return (function (left, right) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Either_1.getEq(left, right), env, { left: left, right: right })); })(e(env).eq, a(env).eq);
    }; },
    option: function (a, config) { return function (env) { return pipeable_1.pipe(a(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Option_1.getEq(eq), env, { eq: eq })); }); }; },
    unknownE: function (a, config) { return function (env) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(a(env).eq, env, {})); }; }
}); });
